var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1273101_cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6499 21.0466H18.5607C18.2993 21.0466 18.125 21.2209 18.125 21.4824V36.4713C18.125 36.7328 18.2993 36.9071 18.5607 36.9071H28.6696V39.1293H25.9245C25.6631 39.1293 25.4888 39.3036 25.4888 39.565C25.4888 39.8264 25.6631 40.0007 25.9245 40.0007H32.2425C32.504 40.0007 32.6783 39.8264 32.6783 39.565C32.6783 39.3036 32.504 39.1293 32.2425 39.1293H29.541V36.9071H39.6499C39.9113 36.9071 40.0856 36.7328 40.0856 36.4713V21.4824C40.0856 21.2645 39.8677 21.0466 39.6499 21.0466ZM39.2141 21.9181V33.2905H18.9965V21.9181H39.2141ZM18.9965 36.0356V34.2056H39.2141V36.0356H18.9965Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6499 21.0466H18.5607C18.2993 21.0466 18.125 21.2209 18.125 21.4824V36.4713C18.125 36.7328 18.2993 36.9071 18.5607 36.9071H28.6696V39.1293H25.9245C25.6631 39.1293 25.4888 39.3036 25.4888 39.565C25.4888 39.8264 25.6631 40.0007 25.9245 40.0007H32.2425C32.504 40.0007 32.6783 39.8264 32.6783 39.565C32.6783 39.3036 32.504 39.1293 32.2425 39.1293H29.541V36.9071H39.6499C39.9113 36.9071 40.0856 36.7328 40.0856 36.4713V21.4824C40.0856 21.2645 39.8677 21.0466 39.6499 21.0466ZM39.2141 21.9181V33.2905H18.9965V21.9181H39.2141ZM18.9965 36.0356V34.2056H39.2141V36.0356H18.9965Z",
    stroke: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18935 22.5269C7.57438 22.5269 7.88651 22.2148 7.88651 21.8297C7.88651 21.4447 7.57438 21.1326 7.18935 21.1326C6.80432 21.1326 6.49219 21.4447 6.49219 21.8297C6.49219 22.2148 6.80432 22.5269 7.18935 22.5269Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18935 22.5269C7.57438 22.5269 7.88651 22.2148 7.88651 21.8297C7.88651 21.4447 7.57438 21.1326 7.18935 21.1326C6.80432 21.1326 6.49219 21.4447 6.49219 21.8297C6.49219 22.2148 6.80432 22.5269 7.18935 22.5269Z",
    stroke: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3354 23.4856V0.435726C14.3354 0.17429 14.1611 0 13.8997 0H0.435726C0.17429 0 0 0.17429 0 0.435726V23.4856C0 23.7471 0.17429 23.9214 0.435726 23.9214H13.8561C14.1175 23.9214 14.3354 23.7471 14.3354 23.4856ZM13.4639 0.871452V19.6948H0.871452V0.871452H13.4639ZM0.871452 23.0499V20.5663H13.4204V23.0499H0.871452Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3354 23.4856V0.435726C14.3354 0.17429 14.1611 0 13.8997 0H0.435726C0.17429 0 0 0.17429 0 0.435726V23.4856C0 23.7471 0.17429 23.9214 0.435726 23.9214H13.8561C14.1175 23.9214 14.3354 23.7471 14.3354 23.4856ZM13.4639 0.871452V19.6948H0.871452V0.871452H13.4639ZM0.871452 23.0499V20.5663H13.4204V23.0499H0.871452Z",
    stroke: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2098 31.5901H8.58239V25.3156C8.58239 25.0542 8.4081 24.8799 8.14666 24.8799C7.88523 24.8799 7.71094 25.0542 7.71094 25.3156V32.0258C7.71094 32.2872 7.88523 32.4615 8.14666 32.4615H17.2098C17.4712 32.4615 17.6455 32.2872 17.6455 32.0258C17.6455 31.7644 17.4276 31.5901 17.2098 31.5901Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2098 31.5901H8.58239V25.3156C8.58239 25.0542 8.4081 24.8799 8.14666 24.8799C7.88523 24.8799 7.71094 25.0542 7.71094 25.3156V32.0258C7.71094 32.2872 7.88523 32.4615 8.14666 32.4615H17.2098C17.4712 32.4615 17.6455 32.2872 17.6455 32.0258C17.6455 31.7644 17.4276 31.5901 17.2098 31.5901Z",
    stroke: "#219653"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8185 8.19176H22.093V19.5642C22.093 19.8257 22.2673 19.9999 22.5287 19.9999C22.7902 19.9999 22.9644 19.8257 22.9644 19.5642V7.75604C22.9644 7.4946 22.7902 7.32031 22.5287 7.32031H15.8185C15.5571 7.32031 15.3828 7.4946 15.3828 7.75604C15.3828 8.01747 15.5571 8.19176 15.8185 8.19176Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8185 8.19176H22.093V19.5642C22.093 19.8257 22.2673 19.9999 22.5287 19.9999C22.7902 19.9999 22.9644 19.8257 22.9644 19.5642V7.75604C22.9644 7.4946 22.7902 7.32031 22.5287 7.32031H15.8185C15.5571 7.32031 15.3828 7.4946 15.3828 7.75604C15.3828 8.01747 15.5571 8.19176 15.8185 8.19176Z",
    stroke: "#219653"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFriendly);
export default __webpack_public_path__ + "static/media/mobileFriendly.608273b92445c932853064f27f2e5688.svg";
export { ForwardRef as ReactComponent };